import unmaskFunctions from '@/utils/unmask'

export default {
    methods: {
        ...unmaskFunctions
    }
}